import React, { useCallback, useEffect, useState } from 'react';
import { Toast } from 'react-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { ToastData } from './toast.type';

export const toastSubject = new BehaviorSubject<ToastData[]>([]);

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastData[]>([]);
  const [mouseOver, setMouseOver] = useState<{ [k: number]: boolean }>({});

  useEffect(() => {
    toastSubject.subscribe((toasts) => {
      setToasts(toasts);
    });
  }, []);

  const handleCloseToast = useCallback(
    (rmToast: ToastData) => () => {
      const newToasts = toastSubject.getValue().filter((toast) => toast.id !== rmToast.id);

      toastSubject.next(newToasts);
    },
    []
  );

  const handleMouseOver = useCallback(
    (toast: ToastData) => () => {
      setMouseOver((mouseOver) => {
        mouseOver[toast.id] = true;

        return { ...mouseOver };
      });
    },
    []
  );

  const handleMouseLeave = useCallback(
    (toast: ToastData) => () => {
      setMouseOver((mouseOver) => {
        delete mouseOver[toast.id];

        return { ...mouseOver };
      });
    },
    []
  );

  return (
    <div className='toast-container'>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          onClose={handleCloseToast(toast)}
          bg={toast.type || 'light'}
          className='mb-2'
          delay={!mouseOver[toast.id] ? toast.delay : undefined}
          onMouseOver={handleMouseOver(toast)}
          onMouseLeave={handleMouseLeave(toast)}
          autohide={!mouseOver[toast.id]}
        >
          <Toast.Header>
            <strong className='me-auto'>{toast.title}</strong>
          </Toast.Header>
          {/* <Toast.Body>{toast.description}</Toast.Body> */}
        </Toast>
      ))}
    </div>
  );
}
